{
  "landingV2": {
    "hero": {
      "overline": "Live practices • events • community",
      "titleLine1": "Love as action.",
      "titleLine2Prefix": "Practice as a",
      "titleAccent": "path.",
      "description1": "Agapella brings together masters, spiritual centers, and human explorers around love as a creative force.",
      "description2": "Through live practices, events, knowledge, and human connection, we create a space where everyone can unfold their potential and move along their own path of development.",
      "actions": {
        "startPractice": "Start practice",
        "viewCalendar": "View calendar"
      }
    },
    "about": {
      "overline": "Who we are",
      "title": "A space for practice, learning, and connection",
      "p1": "We are a multicultural team of researchers, co-creators, and architects of a supportive environment.",
      "p2": "The name Agapella comes from the ancient Greek word Agape — love as action for the good of another person.",
      "p3": "We are building an international platform that unites people from different cultures, traditions, and perspectives around awareness, respect, and shared development.",
      "p4": "Our goal is to make deep practices, live communication, and support from like-minded people accessible to everyone, regardless of country or level of preparation."
    },
    "platform": {
      "overline": "Platform",
      "title": "Everything you need for regular practice",
      "subtitle": "Live sessions, knowledge, masters, and a space for conscious development in one place.",
      "cards": {
        "livePractices": {
          "title": "Live practices",
          "desc": "Join meditations, breathwork, and other live sessions together with masters and participants around the world."
        },
        "masters": {
          "title": "Masters and experts",
          "desc": "Find guides from different traditions and disciplines, learn about their experience, and choose those who resonate with you."
        },
        "quickRooms": {
          "title": "Sesiones en vivo rápidas",
          "desc": "Create your own spaces for conversation, shared practice, and meetings with like-minded people."
        },
        "calendar": {
          "title": "Unified calendar",
          "desc": "Track all platform activity through one schedule for practices, events, and meetings."
        }
      }
    },
    "steps": {
      "overline": "How to start",
      "title": "Your path starts here",
      "items": {
        "createAccount": {
          "title": "Create an account",
          "desc": "Registration takes less than a minute and opens access to all platform features."
        },
        "findDirection": {
          "title": "Find a direction",
          "desc": "Explore practices, events, and masters by the themes that feel close to you."
        },
        "joinPractice": {
          "title": "Join a practice",
          "desc": "Take part in live meetings or study materials at a time that works for you."
        },
        "practiceRegularly": {
          "title": "Practice regularly",
          "desc": "Build your own rhythm, return to practices, and develop through live participation."
        }
      }
    },
    "why": {
      "overline": "Why Agapella",
      "title": "Not just content. A live experience.",
      "cards": {
        "realtimePractice": {
          "title": "Practice in real time",
          "desc": "Agapella is built around live interaction between people. Practice happens not as a recording, but beside others walking a similar path."
        },
        "ownPace": {
          "title": "Develop at your own pace",
          "desc": "Choose practices and meetings that match your current state and life stage."
        },
        "peopleEvents": {
          "title": "People and events",
          "desc": "Find like-minded people, join shared initiatives, and become part of an international community of conscious people."
        }
      }
    }
  },
  "footerV2": {
    "description1": "Agapella is an international live platform and living community that brings people together around love as a creative force.",
    "description2": "We create a space where practices, knowledge, support, and human connection help people unfold their potential and create together.",
    "tagline": "Agapella. From heart to heart.",
    "groups": {
      "navigation": "Navigation",
      "platform": "About platform",
      "legal": "Legal information"
    },
    "links": {
      "practices": "Practices",
      "calendar": "Calendar",
      "masters": "Masters",
      "quickRooms": "Sesiones en vivo rápidas",
      "about": "About us",
      "privacyPolicy": "Privacy Policy",
      "cookieSettings": "Configuración de cookies",
      "termsOfService": "Terms of Service",
      "streamingAgreement": "Streaming Agreement"
    }
  },
  "theme": {
    "mode": "{{mode}} mode"
  }
}
